import { render, staticRenderFns } from "./gauge.vue?vue&type=template&id=baf5492c&scoped=true"
import script from "./gauge.vue?vue&type=script&lang=js"
export * from "./gauge.vue?vue&type=script&lang=js"
import style0 from "./gauge.vue?vue&type=style&index=0&id=baf5492c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf5492c",
  null
  
)

export default component.exports